import React from 'react'
import { mount } from '../utils/mount'
import { PointPage } from '../pages/point-page'

mount('#page-root', <PointPage />)